var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "tool" }, [
                  _c("h4", [_vm._v("选择客户")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客户",
                            loading: _vm.customerLoading,
                            filterable: ""
                          },
                          on: { change: _vm.customerChange },
                          model: {
                            value: _vm.customerValue,
                            callback: function($$v) {
                              _vm.customerValue = $$v
                            },
                            expression: "customerValue"
                          }
                        },
                        _vm._l(_vm.customerData, function(item) {
                          return _c("el-option", {
                            key: item.client_id,
                            attrs: {
                              label: item.number + " " + item.client_name,
                              value: item.client_id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("div", { staticClass: "page_header" }, [
                    _c("i", { staticClass: "el-icon-box header_icon" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("平面转 3D 效果图")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c(
                    "div",
                    { staticClass: "upload_header" },
                    [
                      _c("h5", [
                        _vm._v(
                          "选择平面图（也可裁剪后上传需要生成的区域，会更准确哦）"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "small", plain: "" },
                          on: { click: _vm.openLibrary }
                        },
                        [
                          _c("i", { staticClass: "el-icon-picture-outline" }),
                          _vm._v(" 从生成库选择\n            ")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload_area" },
                    [
                      !_vm.uploadedColorPlan
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload_dragger",
                              attrs: {
                                drag: "",
                                action: "",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.handleColorPlanUpload,
                                accept: "image/*"
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-upload" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "el-upload__text" }, [
                                _vm._v("将文件拖到此处，或"),
                                _c("em", [_vm._v("点击上传")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [_vm._v("支持 JPG、PNG 格式图片")]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "preview_area" },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.uploadedColorPlan,
                                  alt: "预览图"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "clear_btn",
                                  attrs: { type: "danger", size: "small" },
                                  on: { click: _vm.clearColorPlan }
                                },
                                [
                                  _c("i", { staticClass: "el-icon-delete" }),
                                  _vm._v(" 清除\n              ")
                                ]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedPlanName
                    ? _c("div", { staticClass: "selected_plan_info" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("已选择：")
                        ]),
                        _vm._v(_vm._s(_vm.selectedPlanName) + "\n          ")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.uploadedColorPlan
                  ? _c("div", { staticClass: "part" }, [
                      _c("div", { staticClass: "detected_areas_card" }, [
                        _c(
                          "div",
                          { staticClass: "card_header" },
                          [
                            _c("i", { staticClass: "el-icon-view" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.isAnalyzingAreas
                                    ? "正在识别功能区域..."
                                    : "已自动识别功能区域"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.isAnalyzingAreas
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.analyzeFloorplanAreas(
                                          _vm.uploadedColorPlanUrl
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                重新识别\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isAnalyzingAreas && _vm.detectedAreas.length > 0
                          ? _c(
                              "div",
                              { staticClass: "area_tags" },
                              _vm._l(_vm.detectedAreas, function(area) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: area.id,
                                    attrs: { type: "info", effect: "plain" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(area.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm.isAnalyzingAreas
                          ? _c("div", { staticClass: "area_loading" }, [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("AI 正在分析平面图...")])
                            ])
                          : _c("div", { staticClass: "area_empty" }, [
                              _c("span", [_vm._v("未识别到功能区域")])
                            ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.uploadedColorPlan
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("提示词（可选）")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "prompt_input_area" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              placeholder:
                                "输入提示词来定制3D效果图的风格，例如：现代简约风格、北欧风格、中式风格等。留空则使用默认风格。",
                              maxlength: "500",
                              "show-word-limit": "",
                              resize: "none"
                            },
                            model: {
                              value: _vm.stylePrompt,
                              callback: function($$v) {
                                _vm.stylePrompt = $$v
                              },
                              expression: "stylePrompt"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "prompt_tips" }, [
                            _c("i", { staticClass: "el-icon-info" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "提示：详细的风格描述可以生成更符合预期的效果图"
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.uploadedColorPlan
                  ? _c(
                      "div",
                      { staticClass: "part" },
                      [
                        _c("h5", [_vm._v("生成方式")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              "mode_item",
                              { selected: _vm.generate3DFloorPlan }
                            ],
                            on: {
                              click: function($event) {
                                _vm.generate3DFloorPlan = !_vm.generate3DFloorPlan
                              }
                            }
                          },
                          [
                            _c("el-checkbox", {
                              model: {
                                value: _vm.generate3DFloorPlan,
                                callback: function($$v) {
                                  _vm.generate3DFloorPlan = $$v
                                },
                                expression: "generate3DFloorPlan"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mode_info" }, [
                              _c("span", { staticClass: "mode_name" }, [
                                _vm._v("生成3D平面设计图")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mode_desc" }, [
                                _vm._v("除了3D效果图，同时生成3D俯视平面设计图")
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "mode_radio_group",
                            model: {
                              value: _vm.generateMode,
                              callback: function($$v) {
                                _vm.generateMode = $$v
                              },
                              expression: "generateMode"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  "mode_item",
                                  { selected: _vm.generateMode === "all" }
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.generateMode = "all"
                                  }
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: "all" } }, [
                                  _vm._v(_vm._s(""))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mode_info" }, [
                                  _c("span", { staticClass: "mode_name" }, [
                                    _vm._v("全部生成")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mode_desc" }, [
                                    _vm._v(
                                      "生成所有识别区域的 3D 效果图（1.5-1.6m 眼位平视视角）"
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "mode_item",
                                  { selected: _vm.generateMode === "select" }
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.generateMode = "select"
                                  }
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: "select" } }, [
                                  _vm._v(_vm._s(""))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mode_info" }, [
                                  _c("span", { staticClass: "mode_name" }, [
                                    _vm._v("选择区域生成")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mode_desc" }, [
                                    _vm._v("自定义选择需要生成的区域")
                                  ])
                                ])
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.uploadedColorPlan && _vm.generateMode === "select"
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("选择生成区域（可多选）")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "area_select_grid" },
                        _vm._l(_vm.detectedAreas, function(area) {
                          return _c(
                            "div",
                            {
                              key: area.id,
                              class: [
                                "area_item",
                                {
                                  selected: _vm.selectedAreas.includes(area.id)
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.toggleArea(area.id)
                                }
                              }
                            },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  value: _vm.selectedAreas.includes(area.id)
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "area_name" }, [
                                _vm._v(_vm._s(area.name))
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "info_card" }, [
                  _c("div", { staticClass: "info_row" }, [
                    _c("span", { staticClass: "info_label" }, [
                      _vm._v("视角设置")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info_value" }, [
                      _vm._v("1.5-1.6m 眼位平视")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info_row" }, [
                    _c("span", { staticClass: "info_label" }, [
                      _vm._v("渲染内容")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info_value" }, [
                      _vm._v("墙面 / 地面 / 天花板")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn_save" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "success",
                          loading: _vm.isGenerating,
                          disabled:
                            !_vm.uploadedColorPlan ||
                            !_vm.customerValue ||
                            (_vm.generateMode === "select" &&
                              _vm.selectedAreas.length === 0)
                        },
                        on: { click: _vm.handleGenerate }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isGenerating
                                ? "生成中..."
                                : "立即生成 3D 效果图"
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        "（本月剩余使用额度 " +
                          _vm._s(_vm.global.money) +
                          "元）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.generatedImages.length > 0
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("生成结果")]),
                      _vm._v(" "),
                      _vm.floorplanImage
                        ? _c("div", { staticClass: "result_floorplan" }, [
                            _c(
                              "div",
                              { class: ["result_item_3d", "floorplan"] },
                              [
                                _vm.floorplanImage.status === "pending"
                                  ? _c(
                                      "div",
                                      { staticClass: "result_loading" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-loading"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.floorplanImage.area) +
                                              " 生成中..."
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm.floorplanImage.status === "error"
                                  ? _c("div", { staticClass: "result_error" }, [
                                      _c("i", {
                                        staticClass: "el-icon-warning"
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.floorplanImage.area) +
                                            " 生成失败"
                                        )
                                      ])
                                    ])
                                  : [
                                      _c("img", {
                                        staticClass: "result_image",
                                        attrs: {
                                          src: _vm.floorplanImage.url,
                                          alt: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewImage(
                                              _vm.floorplanImage.url
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "result_info" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "result_title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.floorplanImage.area
                                                ) + " - 3D 效果图"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "result_desc" },
                                            [_vm._v("90度正上方俯视视角")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "result_actions" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "success",
                                                    plain: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleCollect(
                                                        _vm.floorplanImage
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("收藏")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "success",
                                                    plain: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleDownload(
                                                        _vm.floorplanImage
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("下载")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.areaImages.length > 0
                        ? _c(
                            "div",
                            { staticClass: "result_list" },
                            _vm._l(_vm.areaImages, function(img, index) {
                              return _c(
                                "div",
                                {
                                  key: "result" + index,
                                  staticClass: "result_item_3d"
                                },
                                [
                                  img.status === "pending"
                                    ? _c(
                                        "div",
                                        { staticClass: "result_loading" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-loading"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(img.area) + " 生成中..."
                                            )
                                          ])
                                        ]
                                      )
                                    : img.status === "error"
                                    ? _c(
                                        "div",
                                        { staticClass: "result_error" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(img.area) + " 生成失败"
                                            )
                                          ])
                                        ]
                                      )
                                    : [
                                        _c("img", {
                                          staticClass: "result_image",
                                          attrs: { src: img.url, alt: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.previewImage(img.url)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "result_info" },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "result_title" },
                                              [
                                                _vm._v(
                                                  _vm._s(img.area) +
                                                    " - 3D 效果图"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "result_desc" },
                                              [_vm._v("1.5m 眼位平视视角")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "result_actions" },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "success",
                                                      plain: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleCollect(
                                                          img
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("收藏")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "success",
                                                      plain: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleDownload(
                                                          img
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("下载")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.exampleList.length > 0
                  ? _c("div", { staticClass: "example_section" }, [
                      _c("div", { staticClass: "example_header" }, [
                        _c("h5", [_vm._v("优质案例")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "example_grid" },
                        _vm._l(_vm.exampleList, function(item) {
                          return _c(
                            "div",
                            {
                              key: "example" + item.id,
                              staticClass: "example_item",
                              on: {
                                click: function($event) {
                                  return _vm.previewExample(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.photo_url +
                                    "?x-oss-process=image/resize,w_300",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择彩平图",
                    visible: _vm.libraryOpen,
                    width: "70%",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.libraryOpen = $event
                    }
                  }
                },
                [
                  _c("p", { staticClass: "dialog_hint" }, [
                    _vm._v("从已生成的彩平图库中选择一张满意的彩平图继续操作")
                  ]),
                  _vm._v(" "),
                  _vm.libraryLoading
                    ? _c("div", { staticClass: "library_loading" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("加载中...")])
                      ])
                    : _vm.colorPlanLibrary.length === 0
                    ? _c("div", { staticClass: "library_empty" }, [
                        _c("i", { staticClass: "el-icon-picture-outline" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无彩平图数据")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "hint" }, [
                          _vm._v('请先在"平面图转彩平"页面生成彩平图')
                        ])
                      ])
                    : _c(
                        "div",
                        { staticClass: "library_grid" },
                        _vm._l(_vm.colorPlanLibrary, function(plan) {
                          return _c(
                            "div",
                            {
                              key: plan.id,
                              staticClass: "library_item",
                              on: {
                                click: function($event) {
                                  return _vm.handleLibrarySelect(plan)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: plan.thumbnail, alt: "" }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "library_item_info" }, [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(_vm._s(plan.name))
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    width: "auto",
                    "close-on-click-modal": true,
                    "custom-class": "image-preview-dialog",
                    "modal-append-to-body": true,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.previewVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "preview-dialog-image",
                    attrs: { src: _vm.previewImageUrl }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "示例详情",
                    visible: _vm.exampleDetailVisible,
                    width: "80%",
                    top: "5vh",
                    "close-on-click-modal": true,
                    "custom-class": "example-detail-dialog"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.exampleDetailVisible = $event
                    }
                  }
                },
                [
                  _vm.currentExample
                    ? _c("div", { staticClass: "example_detail" }, [
                        _vm.currentExample.original_photo_url
                          ? _c("div", { staticClass: "detail_images_row" }, [
                              _c("div", { staticClass: "image_item" }, [
                                _c("p", { staticClass: "image_label" }, [
                                  _vm._v("原始图片")
                                ]),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.original_photo_url,
                                    alt: "原始图"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "image_item" }, [
                                _c("p", { staticClass: "image_label" }, [
                                  _vm._v("生成结果")
                                ]),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.photo_url,
                                    alt: "生成结果"
                                  }
                                })
                              ])
                            ])
                          : _c("div", { staticClass: "detail_single_layout" }, [
                              _c("div", { staticClass: "detail_left" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.photo_url,
                                    alt: ""
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail_right" }, [
                                _c("div", { staticClass: "detail_item" }, [
                                  _c("label", [_vm._v("提示词/描述：")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.currentExample.description)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail_item" }, [
                                  _c("label", [_vm._v("使用模型：")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.currentExample.model_name)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.currentExample.style_type
                                  ? _c("div", { staticClass: "detail_item" }, [
                                      _c("label", [_vm._v("风格类型：")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.currentExample.style_type)
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentExample.space_type
                                  ? _c("div", { staticClass: "detail_item" }, [
                                      _c("label", [_vm._v("空间类型：")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.currentExample.space_type)
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "detail_actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.useThisExample }
                                      },
                                      [_vm._v("使用此提示词")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]),
                        _vm._v(" "),
                        _vm.currentExample.original_photo_url
                          ? _c("div", { staticClass: "detail_info_bottom" }, [
                              _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("提示词/描述：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.description))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("使用模型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.model_name))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.currentExample.style_type
                                ? _c("div", { staticClass: "detail_item" }, [
                                    _c("label", [_vm._v("风格类型：")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.currentExample.style_type)
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentExample.space_type
                                ? _c("div", { staticClass: "detail_item" }, [
                                    _c("label", [_vm._v("空间类型：")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.currentExample.space_type)
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail_actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: { click: _vm.useThisExample }
                                    },
                                    [_vm._v("使用此提示词")]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10691a88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10691a88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ColorTo3D/Index.vue
// module id = null
// module chunks = 